<template>
  <div class="barrage-wrap">
      <div :class="item.class" v-for="(item,index) in list1" :key="index">
        <div class="content">
          {{item.title}}
          <div
            class="circle"
            style="top: 0.3px;"
          ></div>
          <div class="icon"></div>
        </div>
      </div>
  </div>
</template>
<style scoped lang="scss">
.barrage-wrap {
  height: 150px;
  width: 1200px;
  margin: 0 auto;
  position: relative;
  // overflow: hidden;
  .list {
    display: inline-block;
    width: 430px;
    box-sizing: border-box;
    font-size: 16px;
    color: #fff;
    position: absolute;
    border-top-left-radius: 50px;
    border-bottom-left-radius: 50px;
    right: -600px;
    .content {
      padding: 0px 20px 0px 65px;
      height: 50px;
      line-height: 50px;
      display: inline-block;
      position: relative;
      background-size: 100% 100%;
      border-top-left-radius: 50px;
      border-bottom-left-radius: 50px;
      background-position: 35px 0px;
      .circle {
        position: absolute;
        left: 0;
        top: 0;
        width: 36px;
        height: 50px;
        box-sizing: border-box;
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
      .icon {
        position: absolute;
        left: 10px;
        top: 0px;
        width: 145px;
        height: 48px;
        background-repeat: repeat;
        background-size: 100% 100%;
      }
    }
  }
  .red {
    .circle {
      background-image: url(../assets/bg/barrage-bg1-left2.png);
    }
    .content {
      background-image: url(../assets/bg/barrage-bg12.png);
    }
    .icon {
      background-image: url(../assets/bg/barrage-bg1-icon.png);
    }
  }
  .blue {
    .circle {
      background-image: url(../assets/bg/barrage-bg2-left2.png);
    }
    .content {
      background-image: url(../assets/bg/barrage-bg22.png);
    }
    .icon {
      background-image: url(../assets/bg/barrage-bg2-icon.png);
    }
  }
  .an1 {
    top: 20px;
    animation: 17s first-marquee linear 1s infinite normal;
  }

  .an2 {
    top: 20px;
    animation: 17s first-marquee linear 5s infinite normal;
  }
  .an3 {
    top: 20px;
    animation: 17s first-marquee linear 9s infinite normal;
  }
  .an4 {
    top: 20px;
    animation: 17s first-marquee linear 13s infinite normal;
  }
  .an5 {
    top: 83px;
    animation: 18s first-marquee-2 linear 2s infinite normal;
  }
  .an6 {
    top: 83px;
    animation: 18s first-marquee-2 linear 5s infinite normal;
  }
  .an7 {
    top: 83px;
    animation: 18s first-marquee-2 linear 8s infinite normal;
  }
  .an8 {
    top: 83px;
    animation: 18s first-marquee-2 linear 11s infinite normal;
  }
  .an9 {
    top: 83px;
    animation: 18s first-marquee-2 linear 14s infinite normal;
  }
}
@keyframes first-marquee {
  0% {
    -webkit-transform: translate3d(0, 0, 0);
    opacity: 0;
  }
  1% {
    opacity: 1;
  }
  /* 向左移动 */
  55% {
    opacity: 0.9;
  }
  56% {
    opacity: 0.5;
  }
  57% {
    opacity: 0;
  }
  100% {
    transform: translate3d(-2800px, 0, 0);
    opacity: 0;
    display: none;
  }
}
@keyframes first-marquee-2 {
  0% {
    -webkit-transform: translate3d(0, 0, 0);
    opacity: 0;
  }
  1% {
    opacity: 1;
  }
  /* 向左移动 */
  40% {
    opacity: 0.9;
  }
  41% {
    opacity: 0.5;
  }
  42% {
    opacity: 0;
  }
  100% {
    transform: translate3d(-3800px, 0, 0);
    opacity: 0;
    display: none;
  }
}
</style>
<script>
export default {
  name: 'Barrage',
  data() {
    return {
      list1: [
        {
          title: '蓝凌最牛逼的就是服务大企业的能力',
          type: 'red',
          style: 'top: 0.3px;',
          class: 'list an1 red'
        },
        {
          title: '我们不创造系统，我们只是系统的搬运工',
          type: 'blue',
          style: 'top: 0.3px;',
          class: 'list an2 blue'
        },
        { title: '老板说，要全面上钉钉！', type: 'blue', style: 'top: 0.3px;',class: 'list an3 blue' },
        { title: '员工如何快速使用钉钉？', type: 'red', style: 'top: 0.3px;',class: 'list an4 red' },
        {
          title: '企业几十上百个应用，如何快速集成到钉钉？',
          type: 'red',
          style: '',
          class: 'list an5 red'
        },
        {
          title: '蓝凌最牛逼的就是服务大企业',
          type: 'blue',
          style: 'top: 0.3px;',
          class: 'list an6 blue'
        },
        { title: '我们帮您实现5大在线', type: 'blue', style: '',class: 'list an7 blue' },
        { title: '蓝凌最牛逼的就是服务大企业的能力', type: 'red', style: '',class: 'list an8 red' },
        { title: '老板说，要全面上钉钉！', type: 'blue', style: '',class: 'list an9 blue' }
      ]
    }
  }
}
</script>